if (!customElements.get('midi-ticker')) {
  customElements.define('midi-ticker', class extends HTMLElement {
    connectedCallback() {
      this.listeners?.abort();
      this.listeners = new AbortController();
      const button = this.querySelector('[data-ticker-pause]');
      if (!button) return;
      button.hidden = false;
      this.setAttribute('data-enhanced', '');
      button.addEventListener('click', () => {
        const paused = button.getAttribute('aria-pressed') !== 'true';
        button.setAttribute('aria-pressed', String(paused));
        this.toggleAttribute('data-paused', paused);
      }, { signal: this.listeners.signal });
    }
    disconnectedCallback() { this.listeners?.abort(); }
  });
}
